<template>
    <article class="text-center mt-4 p-4">
        <h3>Глава {{ chapter.number }}</h3>
        <p class="text-left" v-html="chapter.text"></p>
    </article>
</template>

<script>
export default {
  name: "Chapter",
  props: {
    chapter: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
</style>
